import React from 'react';
import {
  ButtonGroup, OverlayTrigger, Tooltip,
} from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

type ButtonGroupRadioProps = {
  checked?: any;
  name: string;
  options: {
    icon?: IconProp;
    tooltip?: string;
    label: string;
    value: any;
  }[];
  onChange: (value: any) => void;
}

export default function ButtonGroupRadio({
  checked, name, options, onChange,
}: ButtonGroupRadioProps) {
  return (
    <ButtonGroup className="d-flex z-0">
      {options.map((option) => {
        const buttonLabel = (
          <label className="btn btn-outline-primary btn-sm" htmlFor={`${name}_${option.value}`}>
            {option.icon && <FontAwesomeIcon icon={option.icon} />}
            {option.label}
          </label>
        );

        return (
          <React.Fragment key={option.value}>
            <input
              checked={checked === option.value}
              className="btn-check"
              id={`${name}_${option.value}`}
              name={name}
              type="radio"
              onChange={() => onChange(option.value)}
            />
            {option.tooltip ? (
              <OverlayTrigger
                overlay={<Tooltip id={`${name}_${option.value}_tooltip`}>{option.tooltip}</Tooltip>}
                placement="top"
              >
                {buttonLabel}
              </OverlayTrigger>
            ) : buttonLabel }
          </React.Fragment>
        );
      })}
    </ButtonGroup>
  );
}
